import { useNavigate } from 'react-router-dom';

const UpcomingCompetetionItem = ({show}) => {
    const navigate = useNavigate();

    function handleItemClick(item) {
        // history.push(`/show/${item.id}`);
        navigate(`/show/${item.id}`);
    }
                if(show.status === "Active"){

    return (

        <tr onClick={() => handleItemClick(show)} style={{
            cursor: 'pointer'
        }}>
            <td>{show.name}</td>
            <td>{show.status}</td>
                        <td>{show.startDateTime}</td>

        </tr>

    );

}
}

export default UpcomingCompetetionItem;
